import {
  IconButton,
  InputAdornment,
  TextFieldProps,
  useTheme,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { useField } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getIcon } from 'app/components/ErplyIcon';
import { InputIcon, StyledTextField } from 'app/components/styles';

const TextField: React.FC<
  TextFieldProps & {
    path: string;
    error?: never;
    helperText?: never;
    fullWidth?: never;
  }
> = ({ path, variant = 'outlined', type, ...props }) => {
  const { label } = props;
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const [field, { error, touched }] = useField(`${path}.${label}` ?? '');
  const { t } = useTranslation();

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  let endAdornment = props.InputProps?.endAdornment;
  if (type === 'password') {
    endAdornment = (
      <InputAdornment position="end">
        <IconButton
          size="small"
          aria-label="toggle password visibility"
          onClick={() => {
            setShowPassword((prev) => !prev);
          }}
          onMouseDown={handleMouseDownPassword}
        >
          {showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    );
  } else if (type === 'email') {
    endAdornment = (
      <InputAdornment position="end">
        <IconButton size="small" disabled style={{ color: theme.shade['500'] }}>
          <MailOutlineIcon />
        </IconButton>
      </InputAdornment>
    );
  } else if (type === 'number') {
    endAdornment = (
      <InputAdornment position="end">
        <InputIcon $icon={getIcon('Numbers-123')} />
      </InputAdornment>
    );
  }
  return (
    <StyledTextField
      {...props}
      {...field}
      label={t(`registration.component.inputField.${label}`)}
      className="form-field__max-width"
      type={showPassword ? 'string' : type}
      variant={variant}
      error={error !== undefined && touched}
      helperText={error !== undefined && touched ? error : undefined}
      fullWidth
      InputProps={{ endAdornment }}
    />
  );
};

export default TextField;
